import * as React from 'react';
export const moseySvg = React.forwardRef(function moseySvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#DC5968',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M26.995 14.511v8.835a.236.236 0 0 1-.236.237h-4.412a.236.236 0 0 1-.236-.237v-8.6c0-.553-.03-1.186-.261-1.697a1.483 1.483 0 0 0-.416-.53c-.277-.217-.634-.323-1.09-.323-.853 0-1.512.295-1.72.77-.239.514-.239 1.217-.239 1.783v8.597a.236.236 0 0 1-.236.237h-4.293a.236.236 0 0 1-.236-.237l-.01-8.6c0-.553-.031-1.186-.262-1.697a1.483 1.483 0 0 0-.416-.53c-.277-.217-.634-.323-1.09-.323-.853 0-1.512.295-1.72.77-.239.514-.239 1.217-.239 1.783v8.597a.236.236 0 0 1-.236.237h-4.41A.236.236 0 0 1 5 23.346V8.238C5 8.106 5.105 8 5.236 8H9.37c.131 0 .236.106.236.238v.638c0 .096.106.152.185.098 3.331-2.307 6.575.253 6.608.282.118.093.231.194.334.294.09.09.174.181.256.269a.235.235 0 0 0 .36-.01c.246-.305.554-.592.903-.843a4.552 4.552 0 0 1 1.414-.695c2.79-.958 5.212.964 5.237.982.119.093.231.194.334.295C26.746 11.075 27 12.312 27 14.506l-.005.005Z',
      fill: '#fff',
    }),
  );
});
moseySvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var mosey = {
  category: 'brand',
  colorable: false,
  name: 'mosey',
  svg: moseySvg,
};
